import { Button, Popup } from '../Generic'
import { useState } from 'react'
import './TinkAfterCancelPopup.css'
import { actionReport } from '@methods/actionReport'

interface TinkAfterCancelPopupProps {
  title: string
  thankYouForYourFeedback: string
  sendButtonText: string
  cancelButtonText: string
  visibility: boolean
  handleVisibility: () => void
}

export const TinkAfterCancelPopup = ({
  title,
  thankYouForYourFeedback,
  sendButtonText,
  cancelButtonText,
  visibility,
  handleVisibility,
}: TinkAfterCancelPopupProps) => {
  const [feedback, setFeedback] = useState<string>()
  const [feedbackSent, setFeedbackSent] = useState<boolean>(false)
  const [closeOngoing, setCloseOngoing] = useState<boolean>(false)

  const handleProceed = () => {
    setCloseOngoing(true)

    try {
      actionReport({
        type: 'event.onboarding-web.tink.CANCEL_SURVEY',
        payload: {
          feedback,
        },
      })
      setFeedbackSent(true)

      //eslint-disable-next-line
    } catch (error) {}

    setTimeout(() => {
      handleVisibility()
    }, 2000)
  }

  const handleClose = () => {
    setCloseOngoing(true)
    handleVisibility()
  }

  return (
    <Popup
      visibility={visibility}
      handleVisibility={handleClose}
      closeIconHidden={closeOngoing}
      clickOutsideEnabled={!closeOngoing}
      title={title}
      footer={
        <>
          <Button
            onClick={handleProceed}
            disabled={!feedback || closeOngoing}
            className="button--w164"
          >
            {sendButtonText}
          </Button>
          <Button onClick={handleClose} disabled={closeOngoing} className="button--w164">
            {cancelButtonText}
          </Button>
        </>
      }
    >
      {feedbackSent ? (
        thankYouForYourFeedback
      ) : (
        <textarea
          className="tink-cancel-popup__textarea"
          name="feedback"
          rows={6}
          onChange={(e) => setFeedback(e.target.value)}
        />
      )}
    </Popup>
  )
}
